import styled from 'styled-components'
import { fontType, mediaQuery, toRem } from '../../shared/styles/functions'
import UserForm from '../../shared/components/UserForm'


export const Header = styled.head`
	width: 100%;
	background: #000;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0;
`

export const UserFormContainer = styled.main`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background: linear-gradient(180deg, BLACK -31%,#24A4C4 78%);
	align-items: center;
	padding: 0;
`

export const PaymentContainer = styled.main`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background: white;
	align-items: center;
	padding: 0;
`

export const ContentUserForm = styled.section`
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 53px 123px 46px 123px;
	width: 100%;

	${mediaQuery('md')(`	
	padding: 53px 10px 50px 10px;
  `)}
	
`

export const ContentSummary = styled.section`
	min-height: 100vh;
	background: #24A4C4;

	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 103px 123px 46px 123px;
	width: 100%;

	${mediaQuery('md')(`	
	padding: 53px 10px 0 10px;
  `)}
	
`

export const ContentPayment = styled.section`
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 60px 0 0 0;
	width: 100%;

	${mediaQuery('md')(`	
	padding: 53px 0 0 0;
  `)}
`

export const ImagesContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
	padding: 8px;
	//width: 445px;
`

export const UserInput = styled(UserForm)`

	border: 1px solid black; 
  	border-radius: 10px;     
  	padding: 10px;            


`

